var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoCard',{staticClass:"base-info-container",attrs:{"icon":"iconfont iconExperience","title":_vm.$t(`${_vm.i18nPrefix}.title.${ _vm.isPartTime ? 'partTimeExperience' : 'workExperience' }`),"infoList":_vm.infoList,"infoLines":_vm.infoLines}})
}
var staticRenderFns = []

export { render, staticRenderFns }